export enum PermissionContext {
  APTITUDE = 'APTITUDE',
  BUYER_RFP = 'BUYER_RFP',
  CONTRACT = 'CONTRACT',
  CROSS_REFERENCE = 'CROSS_REFERENCE',
  IMPORT = 'IMPORT',
  OPPORTUNITIES = 'OPPORTUNITIES',
  PURCHASE_PLANNING = 'PURCHASE_PLANNING',
  REVIEW_CONTRACTS = 'REVIEW_CONTRACTS',
  SELLER_RFP_RESPONSE = 'SELLER_RFP_RESPONSE',
}
